export const filtersConfig = [
  {
    id: 'freeCancellation',
    icon: 'CalendarCheck4'
  },
  {
    id: 'breakfastIncluded',
    icon: 'Bowl'
  },
  {
    id: 'payLater',
    icon: 'CreditCard'
  },
  {
    id: 'priceSort',
    icon: 'SortDescending'
  }
] as const

export type FilterKey = (typeof filtersConfig)[number]['id']

export enum FilterSource {
  QuickFilters = 'quickFilters',
  RemoveQuickFilters = 'removeQuickFilters',
  RemoveMoreDealsQuickFilters = 'removeMoreDealsQuickFilters'
}
